const NotFound = () => (
  <svg x="0px" y="0px" width="384.4" height="147.8" viewBox="0 0 384.4 147.8">
    <g>
      <linearGradient id="not-found-gradient" gradientUnits="userSpaceOnUse" x1="192.1949" y1="0" x2="192.1949" y2="147.7805">
        <stop  offset="0" style={{ stopColor: '#FAFAFA' }} />
        <stop  offset="1" style={{ stopColor:'#999999' }} />
      </linearGradient>
      <path fill="url(#not-found-gradient)" d="M66.2,115.5H0v-32L50.1,0h57.8v79.2h15.9v36.3h-15.9v22.1H66.2V115.5z M40.2,79.2h26V35.9L40.2,79.2z
        M193.6,5.6c41.1,0,61.1,33.6,61.1,71c0,37.3-20,71.2-61.1,71.2s-61.1-33.8-61.1-71.2C132.6,39.3,152.6,5.6,193.6,5.6z M193.6,42.4
        c-13.2,0-19.2,10.9-19.2,34.3c0,23.3,6,34.4,19.2,34.4s19.2-11.1,19.2-34.4C212.8,53.3,206.8,42.4,193.6,42.4z M326.8,115.5h-66.2
        v-32L310.7,0h57.8v79.2h15.9v36.3h-15.9v22.1h-41.7V115.5z M300.8,79.2h26V35.9L300.8,79.2z"/>
    </g>
  </svg>
);

export default NotFound;
